/**
 * Codificação de polyline (algoritmo do Google, precisão 5) igual ao plugin `polyline-encoded`
 * (L.Polyline.fromEncoded / encodePath) que a tela usava no corte do deslocamento: os mesmos
 * arredondamentos (`toFixed` nos deltas da codificação, `Math.round` na decodificação), para o
 * worker do scheduler e o navegador produzirem strings idênticas. Sem Leaflet.
 *
 * Portado de polyline-encoded 0.0.9 (MIT, Jan Pieter Waagmeester).
 */
'use strict';

const PRECISION = 5;
const FACTOR = 10 ** PRECISION;

function encodeUnsignedInteger(num) {
    let value;
    let encoded = '';
    while (num >= 0x20) {
        value = (0x20 | (num & 0x1f)) + 63;
        encoded += String.fromCharCode(value);
        num >>= 5;
    }
    value = num + 63;
    encoded += String.fromCharCode(value);
    return encoded;
}

function decodeUnsignedIntegers(encoded) {
    const numbers = [];
    let current = 0;
    let shift = 0;
    for (let i = 0; i < encoded.length; ++i) {
        const b = encoded.charCodeAt(i) - 63;
        current |= (b & 0x1f) << shift;
        if (b < 0x20) {
            numbers.push(current);
            current = 0;
            shift = 0;
        } else {
            shift += 5;
        }
    }
    return numbers;
}

/** "polyline" -> [{ lat, lng }] (como os L.LatLng de L.Polyline.fromEncoded(...).getLatLngs()). */
function decodeToLatLngs(encoded) {
    const numbers = decodeUnsignedIntegers(String(encoded || ''))
        .map((num) => ((num & 1) ? ~(num >> 1) : (num >> 1)) / FACTOR);
    const last = [];
    for (let i = 0; i < numbers.length;) {
        for (let d = 0; d < 2; ++d, ++i) {
            last[d] = numbers[i] + (last[d] || 0);
            numbers[i] = Math.round(last[d] * FACTOR) / FACTOR;
        }
    }
    const points = [];
    for (let i = 0; i + 1 < numbers.length; i += 2) points.push({ lat: numbers[i], lng: numbers[i + 1] });
    return points;
}

/** [{ lat, lng }] -> "polyline" (como L.polyline(latlngs).encodePath()). */
function encodeLatLngs(points) {
    const flat = [];
    for (const point of points || []) {
        flat.push(point.lat || point[0]);
        flat.push(point.lng || point[1]);
    }
    const last = [];
    let out = '';
    for (let i = 0; i < flat.length;) {
        for (let d = 0; d < 2; ++d, ++i) {
            const num = flat[i].toFixed(PRECISION);
            const delta = num - (last[d] || 0);
            last[d] = num;
            let n = Math.round(delta * FACTOR);
            n = (n < 0) ? ~(n << 1) : (n << 1);
            out += encodeUnsignedInteger(n);
        }
    }
    return out;
}

module.exports = { decodeToLatLngs, encodeLatLngs };
